(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diwali-floater"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('diwali-offer-floater')) {
  customElements.define('diwali-offer-floater', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const designMode = Boolean(window.Shopify && window.Shopify.designMode);
      const key = 'diwali-floater-dismissed:' + this.dataset.key;
      const remember = this.dataset.remember === 'true' && !designMode;
      if (remember) {
        try { this.hidden = sessionStorage.getItem(key) === '1'; } catch (_) {}
      }
      const close = this.querySelector('.df-close');
      if (close) close.addEventListener('click', () => {
        this.hidden = true;
        if (remember) {
          try { sessionStorage.setItem(key, '1'); } catch (_) {}
        }
      });
      const button = this.querySelector('.df-offer');
      const status = this.querySelector('.df-status');
      const label = this.querySelector('.df-copy-label');
      button.addEventListener('click', async () => {
        const code = button.dataset.code;
        button.disabled = true;
        let copied = false;
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(code);
            copied = true;
          }
        } catch (_) {}
        if (!copied) {
          const field = document.createElement('textarea');
          field.value = code;
          field.setAttribute('readonly', '');
          field.style.cssText = 'position:fixed;left:-9999px;top:0;font-size:16px;';
          document.body.appendChild(field);
          field.select();
          field.setSelectionRange(0, field.value.length);
          try { copied = document.execCommand('copy'); } catch (_) {}
          field.remove();
          button.focus({ preventScroll: true });
        }
        button.dataset.copied = String(copied);
        label.textContent = copied ? 'Copied!' : 'Try copying again';
        status.textContent = copied ? 'Coupon code ' + code + ' copied to clipboard.' : 'Unable to copy. Please copy the displayed coupon code manually.';
        button.disabled = false;
        clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => { delete button.dataset.copied; label.textContent = 'Copy coupon'; }, 2500);
      });
    }
    disconnectedCallback() { clearTimeout(this.copyTimer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // if (this.headerIsAlwaysSticky) {
      //   this.header.classList.add('shopify-section-header-sticky');
      // }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.querySelector('sticky-header.ct-header_wrapper').offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        // custom setup
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // custom setup
        this.header.classList.add('scrolled-past-header');
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
        // custom settup
        if (this.headerIsAlwaysSticky) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-buy-now-button]');

    if (!btn) return;

    const cartCount = Number(
    document.querySelector('.cart-count-bubble span')?.textContent || 0
    );

    if (cartCount > 0) {
    e.preventDefault();

    document.querySelector('#cart-icon-bubble')?.click();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
